
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"36","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.167 8.833h-5v5H5.834v-5h-5V5.5h5v-5h3.333v5h5v3.333zm16.383 0h5.284c1.833 0 3.333 1.5 3.333 3.334v20c0 1.833-1.5 3.333-3.334 3.333H9.168a3.343 3.343 0 01-3.333-3.333v-15h3.333v15h26.667v-20h-6.75l-3.05-3.334H17.5V5.5h10l3.05 3.333zM22.5 30.5a8.336 8.336 0 01-8.333-8.333c0-4.6 3.733-8.334 8.333-8.334s8.334 3.734 8.334 8.334S27.1 30.5 22.5 30.5zm0-13.333c2.75 0 5 2.25 5 5s-2.25 5-5 5-5-2.25-5-5 2.25-5 5-5z","fill":"#DADADA"}})])
          )
        }
      }
    